import { Injectable, Injector } from '@angular/core';
import { MapToServerSideEnum } from 'src/core/decorators/enum/mapto-server-side-enum.decorator';
import { ServerSideEnum } from './server-side-enum.model';

@Injectable({
  providedIn: 'root',
})
@MapToServerSideEnum('AICoachingPeriodType')
export class AICoachingPeriodType extends ServerSideEnum {
  SevenDays: number;
  FourteenDays: number;
  Monthly: number;

  constructor(injector: Injector) {
    super(injector);
  }
}
